import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { IChannel } from '@/entities/channel';
import { TableSettingsMenuById } from '@/shared/ui/Table';
import { getRoutePath } from '@/shared/utils/routes';

type ChannelsListSettingsProps = {
  channel: IChannel;
  companyId?: string;
  onDelete: (id: string) => Promise<void>;
  onUnlink: (companyId: string, channelId: string) => Promise<void>;
};

export const ActionsButton = ({
  channel,
  companyId,
  onDelete,
  onUnlink,
}: ChannelsListSettingsProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const channelId = channel.id;

  const handleSettings = () => {
    if (channelId) {
      navigate(
        getRoutePath('MAIN', 'CHANNEL')
          .replace(':id', channelId)
          .replace(':tab', 'settings'),
        {
          state: {
            from: location.pathname + location.search,
            isFromCompanies: true,
          },
        }
      );
    }
  };

  const handleUnlink = async () => {
    if (companyId && channelId) {
      await onUnlink(companyId, channelId);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleDelete = async () => {
    if (channelId) {
      await onDelete(channelId);
    }
  };

  return (
    <div>
      <TableSettingsMenuById
        menuItems={[
          {
            label: t('channels:list.menu.settings'),
            onClick: handleSettings,
          },
          {
            label: t('channels:list.menu.unlinkChannel'),
            onClick: handleUnlink,
          },
          // {
          //   label: t('channels:deleteChannel'),
          //   onClick: handleDelete,
          //   color: 'error',
          // },
        ]}
      />
    </div>
  );
};
